const { SelectControl } = wp.components;

const SelectBackground = ({ attributes, setAttributes }) => {
  return (
    <SelectControl
      label="Selecione a cor de fundo desta seção"
      title="Selecione a cor de fundo desta seção"
      value={attributes.background}
      options={[
        { label: 'Branco', value: 'bg-white' },
        { label: 'Preto', value: 'bg-black' },
        { label: 'Azul', value: 'bg-blue' },
        { label: 'Azul Claro', value: 'bg-blue-light' },
        { label: 'Azul Escuro', value: 'bg-blue-dark' },
        { label: 'Azul Anil', value: 'bg-blue-anil' },
        { label: 'Anil Escuro', value: 'bg-anil-dark' },
        { label: 'Laranja', value: 'bg-orange' },
        { label: 'Verde claro', value: 'bg-green-light' },
        { label: 'Cinza', value: 'bg-grey' },
        { label: 'Cinza Claro', value: 'bg-grey-light' },
        { label: 'Cinza Muito Claro', value: 'bg-grey-soft' },
        { label: 'Gradient azul', value: 'bg-gradient' },
        { label: 'Gradient azul inverso', value: 'bg-gradient2' },
        { label: 'Gradient azul (horizontal)', value: 'bg-gradient3' },
        { label: 'Gradient azul inverso (horizontal)', value: 'bg-gradient4' },
        { label: 'Gradient roxo', value: 'bg-gradient5' },
      ]}
      onChange={(position) => setAttributes({ background: position })}
    />
  );
};

export default SelectBackground;
